import { FilterMatchMode } from "primereact/api"

export class ListaActividad {
    model = {
        id: { value: null, export: false },
        actividad: {
            value: null, header: 'Actividad', required: 'Actividad es requerida', table: true, filterField: 'actividad',
            filter: true, sort: true, matchMode: FilterMatchMode.CONTAINS
        },
        area: {
            value: null, header: 'Área / Dirección', required: 'Área es requerido', table: true, filterField: 'area',
            filter: true, sort: true, matchMode: FilterMatchMode.CONTAINS
        },
        sigla_riesgo: {
            value: '', export: true, header: 'ID del Riesgo', required: false, maxLength: 'Máximo 300 caracteres',
            filterPlaceholder: 'ID del Riesgo', minLength: 'Mínimo 4 caracteres', max: 100, min: 3, filterField: 'sigla_riesgo',
            table: true, filter: true, sort: true, matchMode: FilterMatchMode.CONTAINS
        },
        macroproceso_tipo: { header: 'Macroproceso-Tipo', value: null, required: 'Seleccione una opcion', optionLabel: 'nombre', export: false },
        macroproceso_categoria: { header: 'Macroproceso-Categoría', value: null, required: 'Seleccione una opcion', optionLabel: 'nombre', export: false },
        proceso: { header: 'Proceso', value: null, required: 'Seleccione una opcion', optionLabel: 'nombre', table: true, filterField: 'proceso', filter: true, sort: true, matchMode: FilterMatchMode.CONTAINS },
        subproceso: { header: 'Subproceso', value: null, required: 'Seleccione una opcion', optionLabel: 'nombre', export: false },
        riesgo_inherente: { header: 'Riesgo inherente', value: null, required: false, optionLabel: 'nombre', export: true, table: true },
        riesgo_residual: { header: 'Riesgo residual', value: null, table: true, export: true },
        estado: { header: 'Estado', value: null, table: true }
    }
}
